// extracted by mini-css-extract-plugin
export default {"sidebar":"E78YW","accessibilityModeSidebar":"DLHSQ"};